// extracted by mini-css-extract-plugin
module.exports = {"root":"Views_root__1a2x6"};